import React from 'react';
import PropTypes from 'prop-types';
import graphqlPropTypes from '@prisjakt/graphql-proptypes';

import SubCategoryInlineList from './components/inline-list';
import SubCategoryList from './components/list';

import { SubCategoryListingFragment } from '../../../../types';

const SubCategoryListing = props => {
  const { styling } = props;
  const categories = [...props.brands, ...props.categories.nodes];
  if (categories.length === 0) {
    return null;
  }
  switch (styling) {
    case 'inline-list': {
      return <SubCategoryInlineList {...props} categories={categories} />;
    }
    case 'list': {
      return <SubCategoryList {...props} categories={categories} />;
    }
    default:
      return null;
  }
};

SubCategoryListing.propTypes = {
  categories: graphqlPropTypes(SubCategoryListingFragment),
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      pathName: PropTypes.string,
    })
  ),
  styling: PropTypes.oneOf(['inline-list', 'list']),
  limit: PropTypes.number,
  collapse: PropTypes.bool,
};

SubCategoryListing.defaultProps = {
  categories: undefined,
  brands: [],
  styling: 'inline-list',
  limit: 6,
  collapse: false,
};

export default SubCategoryListing;
